import { ChatState, RefreshACSTokenPayload } from '../types'

export const onRefreshACSToken = (
  state: ChatState,
  payload: RefreshACSTokenPayload
): ChatState => {
  const { acsChatToken } = payload

  return {
    ...state,
    acsChatToken,
  }
}
